import Vue from 'vue';
export const loadingState = Vue.observable({ isLoading: false });
